import AuthUser from './user';
import axios from 'axios';
import {apiRoutes} from '../Network/apiRoutes';

// Refresh the expired token and made call to the same API
// This also refreshes CloudFront signed cookies via the backend
export const handleUnAuthorizeError = async (onError: any) => {
  try {
    const res = await axios.post(
      process.env.REACT_APP_API_BASE_URL + apiRoutes.auth.refreshToken,
      { refreshToken: AuthUser.getLocalRefreshToken() },
      { withCredentials: true } // Required to receive new CloudFront cookies
    );
    AuthUser.updateLocalAccessToken({ data: res.data });
    return res.status;
  } catch (err) {
    console.error(err);
    // failed to refresh token, go to login screen
    localStorage.clear();
    onError();
  }
};

// Refresh CloudFront cookies by calling token refresh
// Use this when CloudFront returns 403 (cookies expired)
export const refreshCloudFrontCookies = async (): Promise<boolean> => {
  try {
    const res = await axios.post(
      process.env.REACT_APP_API_BASE_URL + apiRoutes.auth.refreshToken,
      { refreshToken: AuthUser.getLocalRefreshToken() },
      { withCredentials: true }
    );
    if (res.status === 200) {
      AuthUser.updateLocalAccessToken({ data: res.data });
      return true;
    }
    return false;
  } catch (err) {
    console.error('[CloudFront] Failed to refresh cookies:', err);
    return false;
  }
};
